import { alpha, darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  individualNotice: {
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(3),
    borderLeft: `3px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.warning.main, 0.06),
  },
  individualNoticeText: {
    fontSize: 13,
    fontWeight: 700,
    color: darken(theme.palette.warning.main, 0.5),
  },
  headerButton: {
    marginLeft: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
  tabs: {
    marginBottom: theme.spacing(2),
  },
  tabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  tabInfoIcon: {
    display: 'flex',
    alignItems: 'center',
  },
}))

export default useStyles
